<template>
  <div class="big quick-inquiry">
    <div class="page_title">极速问诊设置</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container" style="padding: 10px 20px 20px 20px">
        <!-- 极速问诊1 -->
        <div class="setForm-1">
          <el-form
            :model="setForm1"
            ref="setForm1Ref"
            label-width="120px"
            :rules="rules"
          >
            <div class="setForm-title">极速问诊1</div>
            <el-form-item label="是否开启" prop="is_open">
              <el-radio-group v-model="setForm1.is_open">
                <el-radio :label="1">开启</el-radio>
                <el-radio :label="0">关闭</el-radio>
              </el-radio-group>
            </el-form-item>

            <template v-if="setForm1.is_open == 1">
              <el-form-item label="问诊名称" prop="fast_name">
                <el-input
                  v-model="setForm1.fast_name"
                  size="small"
                  maxlength="10"
                  clearable
                ></el-input>
                <span class="tip">注：仅用于患者端显示</span>
              </el-form-item>

              <el-form-item label="问诊费用" prop="fast_money">
                <el-input-number
                  v-model="setForm1.fast_money"
                  size="small"
                  :min="0.01"
                  :max="999999999.99"
                  :precision="2"
                  :controls="false"
                  style="width: 120px"
                ></el-input-number>
                &nbsp;元
              </el-form-item>

              <el-form-item label="问诊服务时间" prop="fast_time">
                <el-input-number
                  v-model="setForm1.fast_time"
                  size="small"
                  :min="1"
                  :max="9999"
                  :precision="0"
                  :controls="false"
                  style="width: 120px"
                ></el-input-number>
                <span>&nbsp;分钟</span>
              </el-form-item>

              <el-form-item label="问诊超时时间" prop="fast_over_time">
                <el-input-number
                  v-model="setForm1.fast_over_time"
                  size="small"
                  :min="1"
                  :max="14"
                  :precision="0"
                  :controls="false"
                  style="width: 120px"
                ></el-input-number>
                <span>&nbsp;分钟</span>
              </el-form-item>

              <el-form-item label="医生职称" prop="title">
                <el-select
                  v-model="setForm1.title"
                  placeholder="请选择"
                  multiple
                  clearable
                  style="width: 400px"
                >
                  <el-option
                    v-for="item in doctorOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="问诊时间段设置" prop="times">
                <el-time-picker
                  is-range
                  v-model="setForm1.times"
                  range-separator="~"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围"
                  value-format="HH:mm"
                  format="HH : mm"
                  size="small"
                >
                </el-time-picker>
              </el-form-item>
            </template>

            <el-form-item>
              <el-button
                type="primary"
                size="small"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1684') : false
                "
                @click="submitForm('setForm1Ref', 'setForm1')"
                >保存</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <!-- 极速问诊2 -->
        <el-divider></el-divider>
        <div class="setForm-2">
          <el-form
            :model="setForm2"
            ref="setForm2Ref"
            label-width="120px"
            :rules="rules"
          >
            <div class="setForm-title">极速问诊2</div>
            <el-form-item label="是否开启" prop="is_open">
              <el-radio-group v-model="setForm2.is_open">
                <el-radio :label="1">开启</el-radio>
                <el-radio :label="0">关闭</el-radio>
              </el-radio-group>
            </el-form-item>

            <template v-if="setForm2.is_open == 1">
              <el-form-item label="问诊名称" prop="fast_name">
                <el-input
                  v-model="setForm2.fast_name"
                  size="small"
                  maxlength="10"
                  clearable
                ></el-input>
                <span class="tip">注：仅用于患者端显示</span>
              </el-form-item>

              <el-form-item label="问诊费用" prop="fast_money">
                <el-input-number
                  v-model="setForm2.fast_money"
                  size="small"
                  :min="0.01"
                  :max="999999999.99"
                  :precision="2"
                  :controls="false"
                  style="width: 120px"
                ></el-input-number>
                &nbsp;元
              </el-form-item>

              <el-form-item label="问诊服务时间" prop="fast_time">
                <el-input-number
                  v-model="setForm2.fast_time"
                  size="small"
                  :min="1"
                  :max="9999"
                  :precision="0"
                  :controls="false"
                  style="width: 120px"
                ></el-input-number>
                <span>&nbsp;分钟</span>
              </el-form-item>

              <el-form-item label="问诊超时时间" prop="fast_over_time">
                <el-input-number
                  v-model="setForm2.fast_over_time"
                  size="small"
                  :min="1"
                  :max="14"
                  :precision="0"
                  :controls="false"
                  style="width: 120px"
                ></el-input-number>
                <span>&nbsp;分钟</span>
              </el-form-item>

              <el-form-item label="医生职称" prop="title">
                <el-select
                  v-model="setForm2.title"
                  placeholder="请选择"
                  multiple
                  clearable
                  style="width: 400px"
                >
                  <el-option
                    v-for="item in doctorOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="问诊时间段设置" prop="times">
                <el-time-picker
                  is-range
                  v-model="setForm2.times"
                  range-separator="~"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围"
                  size="small"
                  value-format="HH:mm"
                  format="HH : mm"
                >
                </el-time-picker>
              </el-form-item>
            </template>

            <el-form-item>
              <el-button
                type="primary"
                size="small"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1684') : false
                "
                @click="submitForm('setForm2Ref', 'setForm2')"
                >保存</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import marketing from "../../../api/marketing";
export default {
  data() {
    return {
      setForm1: {
        config_fast_id: "",
        is_open: 0,
        fast_name: "",
        fast_money: undefined,
        fast_time: undefined,
        fast_over_time: undefined,
        title: [],
        times: [],
      },
      setForm2: {
        config_fast_id: "",
        is_open: 0,
        fast_name: "",
        fast_money: undefined,
        fast_time: undefined,
        fast_over_time: undefined,
        title: [],
        times: [],
      },
      doctorOptions: [
        {
          label: "主任医师",
          value: "主任医师",
        },
        {
          label: "副主任医师",
          value: "副主任医师",
        },
        {
          label: "主治医生",
          value: "主治医生",
        },
        {
          label: "住院医师",
          value: "住院医师",
        },
      ],
      rules: {
        is_open: [{ required: true, message: "请选择", trigger: "change" }],
        fast_name: [{ required: true, message: "请输入", trigger: "change" }],
        fast_money: [{ required: true, message: "请输入", trigger: "change" }],
        fast_time: [{ required: true, message: "请输入", trigger: "change" }],
        fast_over_time: [
          { required: true, message: "请输入", trigger: "change" },
        ],
        times: [{ required: true, message: "请选择", trigger: "change" }],
      },
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      let loading = this.$loading();
      marketing
        .getConsultFastConfig()
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            let list = data.list.map((item) => {
              let start_time = dayjs.unix(item.start_time).format("HH:mm");
              let end_time = dayjs.unix(item.end_time).format("HH:mm");
              item = _.omit(item, ["start_time", "end_time"]);
              item.times = [start_time, end_time];
              item.title =
                item.title == "" || !item.title ? [] : item.title.split(",");
              return item;
            });

            this.setForm1 = Object.assign({}, list[0]);
            this.setForm2 = Object.assign({}, list[1]);
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    submitForm(formName, dataName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let loading = this.$loading();
          let params = Object.assign({}, this[dataName]);
          params = _.omit(params, ["times"]);
          let times = this[dataName].times;
          params["start_time"] = times ? times[0] : "";
          params["end_time"] = times ? times[1] : "";
          params.title = params.title.join(",");
          marketing
            .setConsultFastConfig(params)
            .then((res) => {
              let { code } = res;
              if (code === 0) {
                this.$message.success("保存成功");
                this.getInfo();
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.quick-inquiry {
  .setForm-title {
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .tip {
    display: inline-block;
    width: 456px;
    text-align: left;
    padding-left: 10px;
  }
  .setForm-1 {
    width: 800px;
  }
  .setForm-2 {
    width: 800px;
  }
  ::v-deep(.el-form-item__content) {
    display: flex;
    align-items: center;
  }
}
</style>
